/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import React, { useState, useRef, useEffect } from "react";

const MAX_DURATION = 120; // seconds
const WARNING_TIME = 90;

export default function VoiceRecorder({ onRecordingComplete }) {
  const [isRecording, setIsRecording] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const mediaRecorderRef = useRef(null);
  const chunks = useRef([]);
  const timerRef = useRef(null);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorderRef.current = mediaRecorder;

    chunks.current = [];
    setSeconds(0);

    mediaRecorder.ondataavailable = (event) => {
      chunks.current.push(event.data);
    };

    mediaRecorder.onstop = () => {
      clearInterval(timerRef.current);
      timerRef.current = null;

      const audioBlob = new Blob(chunks.current, { type: "audio/ogg" });
      chunks.current = [];

      onRecordingComplete(audioBlob);
    };

    mediaRecorder.start();
    setIsRecording(true);

    timerRef.current = setInterval(() => {
      setSeconds((prev) => {
        if (prev + 1 >= MAX_DURATION) {
          stopRecording(); // ⛔ hard stop
        }
        return prev + 1;
      });
    }, 1000);
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current?.state === "recording") {
      mediaRecorderRef.current.stop();
    }
    setIsRecording(false);
  };

  useEffect(() => {
    return () => {
      clearInterval(timerRef.current);
    };
  }, []);

  return (
    <div>
      <div style={{ marginBottom: 8 }}>
        ⏱ {seconds}s / {MAX_DURATION}s
        {seconds >= WARNING_TIME && seconds < MAX_DURATION && (
          <span style={{ color: "orange", marginLeft: 8 }}>
            Approaching 2-minute pilot limit
          </span>
        )}
      </div>

      {isRecording ? (
        <button onClick={stopRecording}>🛑 Stop Recording</button>
      ) : (
        <button onClick={startRecording}>🎙️ Start Recording</button>
      )}
    </div>
  );
}